import React, { useEffect, useState, useMemo, useCallback } from "react"
import "../User2/UserProfile.css"
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar"
import AdminWrapper from "./AdminWrapper"
import { connect } from "react-redux"
import { API } from "../../API";
import { DataGrid, GridCellModes } from "@mui/x-data-grid";
import NumberInputIntroduction from "../../Components/custom-mui/InputNumber"



const moment = require("moment")


const AdminQualification = (props) => {

	const [qualifications, setQualifications] = useState([])

	const columns = [
		{
			field: "qualification_name",
			headerName: "Training Package",
			// minWidth: 580,
			flex: 4,
			editable: false,
			headerAlign: "center",
		},
		{
			field: "code",
			headerName: "Code",
			// minWidth: 200,
			flex: 1,
			editable: false,
			align: "center",
			headerAlign: "center",
		},
		{
			type: 'number',
			field: "hourly_rate",
			headerName: "Default Hourly Rate",
			editable: true,
			align: "center",
			headerAlign: "center",
			// minWidth: 200,
			flex: 2,
			renderEditCell: (params) => (
				<NumberInputIntroduction 
					{...params}
					placeholder="Hourly rate (number)"
					// value={params.formattedValue} 
					onValueChange={(_, value) => onHourlyRateChange(params.row, value)}
				/>
			),
		},
		{
			field: "createdAt",
			headerName: "Date Created",
			type: "text",
			// minWidth: 180,
			editable: false,
			align: "center",
			headerAlign: "center",
			flex: 2
		}
	];

	useEffect(async () => {
		const usingCache = 'no'
		API.getQualificationList(usingCache).then(result => {
			const qualificationData = result?.data?.data
				.filter(ele => ele.type === 'vet')
				.map(qua => {
					return {
						id: qua._id,
						_id: qua._id,
						qualification_name: qua.qualification_name,
						code: qua.code,
						createdAt: moment.tz(qua.createdAt, "Australia/Melbourne").format("DD-MM-YYYY HH:mm:ss"),
						hourly_rate: qua.hourly_rate || 55,
						type: qua.type
					}
			})
			
			setQualifications(qualificationData)
		})
	}, [])

	/**
	 * Just empty function for working with the flow
	 * @param {*} row 
	 * @param {*} value 
	 */
	const onHourlyRateChange = (row, value) => {

	}

	const saveQualificationData = (newData) => {
		return API.updateQualification(newData.id, {
			hourly_rate: newData.hourly_rate
		}).then(() => {
			const qualificationIndex = qualifications.findIndex(item => item.id === newData.id)
			const newQualifications = [
				...qualifications.slice(0, qualificationIndex),
				{
					...newData
				},
				...qualifications.slice(qualificationIndex + 1)
			]

			setQualifications(newQualifications)
			return newData
		})
	}

	const handleProcessRowUpdateError = React.useCallback((error) => {
		console.log("error on updating: ", error)
    // setSnackbar({ children: error.message, severity: 'error' });
  }, []);

	return (
		<AdminWrapper>
			<SwitchMenuBar isViewAsTeacher />

			<div className="page-container-main bg-photoregister">
				<div className="bg-gradient page-container-bg"></div>
				<div className="page-container-header">
					<div className="page-container-header-inner">
						<div className="d-flex flex-row align-items-center">
							<div className="p-2">
								<h1>Manage VET Qualification</h1>
							</div>
						</div>
					</div>
				</div>
				<div className="page-container-inner">
					{qualifications?.length ? 
					<DataGrid
						rows={qualifications}
						columns={columns}
						hideFooterPagination
						processRowUpdate={(updatedRow, originalRow) => saveQualificationData(updatedRow)}
						onProcessRowUpdateError={handleProcessRowUpdateError}
						
					/> : null}
				</div>
			</div>
		</AdminWrapper>
	)
}

function mapStateToProps(state) {
	return {
		teacher: state.admin.teacher,
	}
}

export default connect(mapStateToProps)(AdminQualification)


